import React from "react";

import { Button, Container } from "react-bootstrap";

import PressComponent from "@/components/mediaCoverage/Press.component";
import PressReleaseComponent from "@/components/mediaCoverage/PressRelease.component";
import TvComponent from "@/components/mediaCoverage/Tv.component";
import useActiveSection from "@/hooks/useActiveSection";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const SECTIONS = [
  { id: "television", label: "Television" },
  { id: "press-releases", label: "Press Releases" },
  { id: "in-the-press", label: "In The Press" },
] as const;

// Module-level so the hook does not re-bind its listeners on every render.
const SECTION_IDS = SECTIONS.map((section) => section.id);

const MediaCoverage = (): React.JSX.Element => {
  const { t } = i18n;
  const { active, scrollTo } = useActiveSection(SECTION_IDS);

  return (
    <React.Fragment>
      <DocumentComponent title={t("media_coverage")} />

      <BannerComponent description="" title={t("media_coverage")} />

      <div className="mediaSectionNav mb-5">
        <Container
          aria-label={t("media_coverage")}
          as="nav"
          className="d-flex justify-content-center gap-2 gap-lg-4"
        >
          {SECTIONS.map((section) => {
            const isActive = section.id === active;
            return (
              <Button
                key={section.id}
                active={isActive}
                aria-pressed={isActive}
                className="btn-outline w-100"
                onClick={() => scrollTo(section.id)}
                size="lg"
                variant="outline-success"
              >
                {t(section.label)}
              </Button>
            );
          })}
        </Container>
      </div>

      <Container
        fluid
        as="section"
        className="mediaSection p-4 mb-2"
        id={SECTIONS[0].id}
        style={{ backgroundColor: "var(--bg-light-color)" }}
      >
        <TvComponent />
      </Container>

      <Container
        fluid
        as="section"
        className="mediaSection p-4 mb-2"
        id={SECTIONS[1].id}
      >
        <PressReleaseComponent />
      </Container>

      <Container
        fluid
        as="section"
        className="mediaSection p-4 mb-4"
        id={SECTIONS[2].id}
        style={{ backgroundColor: "var(--bg-light-color)" }}
      >
        <PressComponent />
      </Container>

      <ScheduleComponent />

      <br />
      <br />
      <br />
    </React.Fragment>
  );
};

export default MediaCoverage;
